"use client";

import { ProgressProvider } from "@bprogress/next/app";
import { ReactNode } from "react";

export const ProgressBarProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ProgressProvider
      color={"#ceff3e"}
      height={"4px"}
      options={{ showSpinner: false }}
    >
      {children}
    </ProgressProvider>
  );
};
